import { Phone, MessageCircle } from "lucide-react";

interface FloatingCTAPreviewProps {
  settings: {
    text: string;
    position: string;
    backgroundColor: string;
    textColor: string;
    icon: string;
    size: string;
    animation: string;
  };
}

export const FloatingCTAPreview = ({ settings }: FloatingCTAPreviewProps) => {
  const { text, position, backgroundColor, textColor, icon, size, animation } = settings;

  const positionClasses = {
    "bottom-right": "bottom-6 right-6",
    "bottom-left": "bottom-6 left-6",
    "top-right": "top-6 right-6",
    "top-left": "top-6 left-6",
  };

  const sizeClasses = {
    sm: "px-4 py-2 text-sm",
    md: "px-5 py-3 text-base",
    lg: "px-6 py-4 text-lg",
  };

  const animationClasses = {
    none: "",
    pulse: "animate-pulse",
    bounce: "animate-bounce",
  };

  return (
    <button
      className={`fixed ${positionClasses[position as keyof typeof positionClasses]} ${
        sizeClasses[size as keyof typeof sizeClasses]
      } ${animationClasses[animation as keyof typeof animationClasses]} rounded-full shadow-2xl font-bold flex items-center gap-2 z-[9999] transition-all hover:scale-110 active:scale-95 cursor-pointer backdrop-blur-sm`}
      style={{ 
        backgroundColor, 
        color: textColor,
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.1)'
      }}
      onClick={() => {
        // يمكن إضافة وظيفة الاتصال أو الواتساب هنا
        console.log('Floating CTA clicked');
      }}
    >
      {icon === "whatsapp" && <Phone className="h-5 w-5 animate-pulse" />}
      {icon === "chat" && <MessageCircle className="h-5 w-5 animate-pulse" />}
      <span className="whitespace-nowrap">{text}</span>
    </button>
  );
};
